import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from '../core/session.service';

@Component({
  standalone: false,
  selector: 'car',
  templateUrl: './car.component.html',
  styleUrls: ['./car.component.scss']
})
export class CarComponent implements OnDestroy {

  routerSubscription: Subscription;

  constructor(
    private router: Router,
    private sessionService: SessionService) {
    this.routerSubscription = router.events
      .subscribe(x => {
        if (this.sessionService.getSessionData().globalErrorTriggered) {
          this.sessionService.getSessionData().globalErrorTriggered = false;
          router.navigate(['/error',
            this.sessionService.getSessionData().globalErrorReason]);
        }
      });
  }

  ngOnDestroy() {
    this.routerSubscription?.unsubscribe();
  }
}
